export const translationTestKeys = [
    'sys.premium_support',
    'sys.skip_the_line',
    'sys.sms_notification',
    'sys.stay_in_the_loop',
    'sys.tier1_flexible_cancellation',
    'sys.cancel_or_modify',
    'sys.time_left_to_process_credit_card',
    'check_order.outbound_trip_info',
    'sys.fare_terms',
    'check_order.check_order_passenger',
    'check_order.buyer_info_section.title',
    'check_order.buyer_info_section.email_note',
    'check_order.buyer_info_section.phone_contact_note',
    'sys.enhance_your_journey',
    'sys.have_a_voucher',
    'sys.click_here_to_apply',
    'sys.total',
    't_summary.gdpr_consent_email_offers',
    'user_messages.purchase_time_expired',
    'user_messages.ticket_purchase_timeout'
]